module.exports = __webpack_public_path__ + "static/media/recipe_category_13.74cc96bb.png";